import { Radio } from '@headlessui/react';
import cn from 'classnames';

import React from 'react';

const RadioWithLabel = React.forwardRef<
  HTMLDivElement,
  {
    option: { label: string; value: string };
    className?: string;
  }
>(({ option, className }, ref) => {
  return (
    <Radio
      ref={ref}
      value={option}
      className={cn('group flex cursor-pointer items-center gap-2', className)}
    >
      <div className="flex h-4 w-4 items-center justify-center rounded-full ring-1 ring-white group-data-[checked]:ring-2 group-data-[checked]:ring-primary-500">
        <div className="h-2 w-2 rounded-full group-data-[checked]:bg-primary-500"></div>
      </div>
      <p className="body16 dark:text-white">{option.label}</p>
    </Radio>
  );
});

export default RadioWithLabel;
